// Product Group
(() => {
  const FF = {
    UPDATE_LABEL_COUNT: true,
    HIDE_OUT_OF_STOCK: false,
  };

  function $q(selector, ctx) {
    ctx = ctx || document;
    return ctx.querySelector(selector);
  }

  async function initializeSiblings(parent) {
    const active_product_group = JSON.parse(
      parent.querySelector(
        'script[type="application/json"][data-product-group-info]'
      ).textContent
    );

    const active_group_id = active_product_group.id;
    console.log("Active Group:", active_group_id);

    let el = {};
    parent._el = el;
    el.color = $q('[data-sibling-type="color"]', parent);
    el.material = $q('[data-sibling-type="material"]', parent);
    el.styledFirstElSelector = ".select-popout__list .select-popout__item";

    console.log("Color Element - innerHTML:", el.color);

    function allKeysMatch(o1, o2) {
      return Object.keys(o1).every((k) => o1[k] === o2[k]);
    }

    function formatProductsData(products) {
      return products
        .map((product) => {
          let product_group = product._product_group;
          if (!product_group) return null;
          let prod = { ...product, _product_group: { ...product_group } };

          prod._product_group._is_current = allKeysMatch(
            product_group,
            active_product_group
          );
          return prod;
        })
        .filter(
          (product) =>
            product && (FF.HIDE_OUT_OF_STOCK ? product.available : true)
        )
        .sort((p1, p2) => {
          let a = p1._product_group;
          let b = p2._product_group;

          let m1 = a.material || "";
          let m2 = b.material || "";

          let c1 = a.color || "";
          let c2 = b.color || "";
          return m1.localeCompare(m2) || c1.localeCompare(c2);
        });
    }

    function updateSiblingDOM(products) {
      let added = { color: {}, material: {} };

      ["color", "material"].forEach((k) => {
        let elementNode = el[k];
        // let styledListItem = $q(el.styledFirstElSelector, elementNode)?.cloneNode(true)

        let htmlsList = products.map((prod) => {
          let optionsHtml = "";
          let styledSelectHtml = "";

          if (added[k][prod._product_group[k]]) {
            return ["", ""];
          }

          // Show all materials
          // But only show colors that have the current material available
          if (
            (k == "color" &&
              prod._product_group.material == active_product_group.material) ||
            k !== "color"
          ) {
            added[k][prod._product_group[k]] = true;

            optionsHtml = `<option value="${
              prod._product_group[k]
            }" data-handle="${prod.handle}" ${
              prod._product_group[k] == active_product_group[k]
                ? "selected"
                : ""
            }>${prod._product_group[k]}</option>`;
            styledSelectHtml = `<li class="select-popout__item ${
              prod._product_group[k] == active_product_group[k]
                ? "select-popout__item--current"
                : ""
            }">
              <a class="select-popout__option" href="#" data-handle="${
                prod.handle
              }" ${
              prod._product_group[k] == active_product_group[k]
                ? 'aria-current="true"'
                : ""
            } data-value="${prod._product_group[k]}" data-popout-option="">
                <span>${prod._product_group[k]}</span>
              </a>
            </li>`;
          }

          return [optionsHtml, styledSelectHtml];
        });

        const totalCount = Object.keys(added[k]).length;

        // console.log({option: k, totalCount })

        const [nativeOptionsHtml, styledOptionsHtml] = htmlsList.reduce(
          (htmlTuple, tuple, i) => {
            htmlTuple[0] += tuple[0];
            htmlTuple[1] += tuple[1];
            return htmlTuple;
          },
          ["", ""]
        );

        if (el[k]) {
          const isNative = el[k].nodeName === "SELECT" || $q("select", el[k]);
          // Update color/material select options
          if (isNative) {
            el[k].innerHTML = nativeOptionsHtml;
          } else if (parent._IS_STYLIZED) {
            // Update color/material styled select options
            const firstItem = $q("[data-popout-list] li", el[k]);
            firstItem.parentElement.innerHTML = styledOptionsHtml;
          }

          // Update label with count
          if (FF.UPDATE_LABEL_COUNT) {
            let labelEl = $q("[data-label-title]", el[k]);
            updateLabelWithCount(labelEl, totalCount);
          }
        }
      });

      return products;
    }

    function updateLabelWithCount(labelEl, count) {
      let currentTitle =
        labelEl.getAttribute("data-label-title") || label.textContent;
      let nextTitle = `Available in ${count} ${currentTitle}${
        count != 1 ? "s" : ""
      }`;

      labelEl.setAttribute("data-new-title", nextTitle);
      labelEl.textContent = nextTitle;
    }

    function onChangeOrClick(e) {
      let change = e.type === "change";
      let click = !change && e.type === "click";

      let target = e.target;
      let currentValue = target.value;

      let changedIn = target.closest("[data-sibling-type]");
      if (!changedIn) {
        return;
      }

      let handle = target.getAttribute("data-handle") || null;

      if (click) {
        if (!handle) {
          target = target.closest(".select-popout__option");
          handle = target?.getAttribute("data-handle") || null;
        }

        if (handle) {
          e.stopPropagation();
          e.preventDefault();
        }
      }

      if (!handle) {
        return;
      }

      let changedOption = changedIn.getAttribute("data-sibling-type");
      let parentContainer = el[changedOption];

      // console.log({ changedOption, parentContainer });
      if (!parentContainer) {
        return;
      }

      if (click) {
        let isItem = target.classList.contains("select-popout__option");
        if (!isItem || target.getAttribute("aria-current") === "true") {
          if (isItem) {
            // Click on toggle button to close the dropdown
            target
              .closest(".select-popout")
              ?.querySelector(".select-popout__toggle")
              ?.click();
          }
          return;
        }

        let titleEl =
          target._titleEl ||
          (target._titleEl = target
            .closest(".select-popout")
            .querySelector(".select-popout__value"));
        currentValue =
          target.getAttribute("value") || target.getAttribute("data-value");
        titleEl.textContent = currentValue;
      }

      if (changedOption == "material") {
        let selectedMaterial = currentValue;
        let selectedColor = active_product_group.color;
        let materialColorSibling = parent._all_products.find(
          (prod) =>
            prod._product_group.color === selectedColor &&
            prod._product_group.material === selectedMaterial
        );
        if (materialColorSibling) {
          handle = materialColorSibling.handle;
        }
      }

      let inQuickview = parent._inQuickview;
      if (!inQuickview) {
        parentContainer?.setAttribute("disabled", "true");
        document.body.setAttribute("data-state", "navigating");
        window._sibling_navigating = true;
        document.body.style.opacity = 0.7;
        let nextPath =
          window.location.pathname.split("/products")[0] +
          "/products/" +
          handle;
        window.location.href = nextPath;
      } else if (window._QuickViewPopup) {
        let b = document.createElement("button");
        b.setAttribute("data-handle", handle);
        b.setAttribute("data-button-quick-view", "");

        let w = document.createElement("div");
        w.style.display = "none";
        w.appendChild(b);

        document.body.appendChild(w);
        new _QuickViewPopup(w);

        parent._inQuickview.querySelector("[data-popup-close]")?.click();
        setTimeout(() => {
          b.click();
        }, 500);
      }
    }

    async function main() {
      document.body.setAttribute("data-state", "idle");

      return SiblingVariantProducts.fetch(active_group_id)
        .then(formatProductsData)
        .then(updateSiblingDOM)
        .then((products) => {
          window.products_by_group = window.products_by_group || {};
          window.products_by_group[active_group_id] = products;

          return { products };
        });
    }

    // ----------------

    const { products } = await main();
    return { onChangeOrClick, el, products };
  }

  // ------------------------------------------------------------

  class SiblingVariantProducts extends HTMLElement {
    static _fetch_cache = {}; // Add semicolon here

    // Static fetch method with proper formatting
    static fetch(group_id) {
      let promise = this._fetch_cache[group_id];
      if (!promise) {
        promise = window
          .fetch(
            `/collections/all?view=product-group-api&sort_by=manual&filter.p.m.my-fields.title_front=${group_id}`,
            { credentials: "omit" }
          )
          .then((r) => {
            console.log("Raw Fetch Response:", r); // Check the raw fetch response
            return r.json();
          })
          .then((data) => {
            console.log("Fetched Data:", data); // Check the parsed JSON data
            return data;
          })
          .catch((err) => {
            console.error("Error fetching data:", err); // Catch any fetch errors
          });
        this._fetch_cache[group_id] = promise;
      }
      return promise;
    }

    // Constructor
    constructor() {
      super(); // Required call to the parent class's constructor
      this._connected = false; // Semicolon added
    }
    // connectedCallback lifecycle method
    async connectedCallback() {
      this._connected = true;
      await Promise.resolve();
      if (!this._connected) return;

      this._ac && this._ac.abort();
      this._ac = new AbortController();

      if (typeof this.mount === "function") {
        await this.mount();
      }
    }
    // disconnectedCallback lifecycle method
    async disconnectedCallback() {
      this._connected = false;
      await Promise.resolve();
      if (this._connected) return;

      if (typeof this.unmount === "function") {
        this.unmount();
      }

      if (this._ac) {
        this._ac.abort();
        this._ac = null;
      }
    }

    // Mount method (moved inside the class)
    async mount() {
      let inQuickview = this.closest("#shopify-section-api-quickview");

      this._inQuickview = inQuickview;
      this._IS_STYLIZED = this.hasAttribute("data-stylized");
      let result = await initializeSiblings(this, SiblingVariantProducts);

      this._all_products = result.products;
      if (result.onChangeOrClick) {
        let eventName = this._IS_STYLIZED ? "click" : "change";
        this.addEventListener(eventName, result.onChangeOrClick, {
          capture: true,
          signal: this._ac.signal,
        });

        [this, result.el.color, result.el.material].forEach((x) => {
          if (!x) return;
          x.removeAttribute("data-pending");
        });
      }
    }
  }

  // Ensure the custom element is defined
  if (!window.customElements.get("sibling-variant-products")) {
    window.customElements.define(
      "sibling-variant-products",
      SiblingVariantProducts
    );
  }
})();
